/**
 *
 * @module memoryStore
 *
 */

/**
 *
 * @class MemoryStore
 * @desc Simple storage implementation, based on a plain Object
 * @since 2.1.0
 *
 */
export default class MemoryStore {

    constructor() {

        /**
         *
         * @access private
         * @type {Object}
         * @desc local store
         *
         */
        this.store = {};

    }

    /**
     *
     * @access public
     * @method setItem
     * @param {String} key
     * @param {Object} value
     * @returns {Object}
     *
     */
    setItem(key, value) {

        this.store[key] = value;

        return this.store[key];

    }

    /**
     *
     * @access public
     * @method getItem
     * @param {String} key
     * @returns {String}
     *
     */
    getItem(key) {

        return this.store[key];

    }

    /**
     *
     * @access public
     * @method removeItem
     * @param {String} key
     * @returns {Undefined}
     *
     */
    removeItem(key) {

        delete this.store[key];

        return undefined;

    }

    /**
     *
     * @access public
     * @method clear
     * @returns {Object}
     *
     */
    clear() {

        this.store = {};

        return this.store;

    }

}



// WEBPACK FOOTER //
// ./src/services/platforms/memoryStore.js